<watchlist-filter class="d-flex {active() && 'active'} {props.class}">
  <div class="icon mr-1" onclick={event => toggle(event)}>
    <dfk-icon type="bookmark" />
  </div>

  <div>
    <a
      href="#"
      class="toggle"
      onclick={event => toggle(event)}
    >

      {label()}
      <template if={!active()}>
        <span class="ml-1">({watchlist.count()})</span>
      </template>
    </a>

    <div if={watchlist.count() > 0}>
      <a
        href="#"
        onclick={event => clearWatchlist(event)}
      >{t('clear_watchlist')}</a>
    </div>
  </div>

  <script>
    import {Url} from '@wendig/lib'
    import watchlist from '../lib/watchlist'

    export default class {
      constructor() {
        this.watchlist = watchlist
      }

      value() {
        return (this.props.criteria || {})['favorites']
      }

      active() {
        return !!this.value()
      }

      toggle(event) {
        event.preventDefault()

        this.set(!this.value())
      }

      set(value) {
        let url = Url.current()
        url.setHashParams(value ? {favorites: true} : {})
        url.apply()
      }

      clearWatchlist(event) {
        event.preventDefault()
        
        watchlist.clear()
        this.set(false)
      }

      label() {
        return this.active() ?
          this.cap(this.t('back_to_article_list')) :
          this.cap(this.t('show_favorites_only'))
      }
    }
  </script>

</watchlist-filter>